const SLIDE_INTERVAL_MS = 5000;

const ACTIVE_SLIDE_CLASS = 'slider__slide--active';
const ACTIVE_DOT_CLASS = 'slider__dot--active';
const PHOTO_ONLY_CLASS = 'hero-section--photo-only';

export function initSlider() {
  const $slider = $('.hero-section__cover-slider [data-slider]');
  if (!$slider.length) return;

  const $slides = $slider.find('.slider__slide');
  if ($slides.length <= 1) return;

  const $hero = $slider.closest('.hero-section');
  const $dotsContainer = $('.hero-section__slider-dots [data-slider-dots]');
  const $dots = $dotsContainer.find('.slider__dot');

  let currentIndex = 0;
  let sliderInterval = null;

  const setActiveSlide = (index) => {
    if (index === currentIndex) return;

    currentIndex = index;

    $slides.removeClass(ACTIVE_SLIDE_CLASS);
    $slides.eq(currentIndex).addClass(ACTIVE_SLIDE_CLASS);

    if ($dots.length) {
      $dots.removeClass(ACTIVE_DOT_CLASS);
      $dots.eq(currentIndex).addClass(ACTIVE_DOT_CLASS);
    }

    $hero.toggleClass(PHOTO_ONLY_CLASS, currentIndex !== 0);
  };

  const startAutoSlide = () => {
    sliderInterval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % $slides.length;
      setActiveSlide(nextIndex);
    }, SLIDE_INTERVAL_MS);
  };

  const restartAutoSlide = () => {
    if (sliderInterval) clearInterval(sliderInterval);
    startAutoSlide();
  };

  if ($dots.length) {
    $dots.on('click', function () {
      const index = $dots.index(this);
      setActiveSlide(index);
      restartAutoSlide();
    });
  }

  startAutoSlide();
}
